const cleanQuizText = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.replace(/\u00a0/g, ' ').trim();
};

const buildFallbackFeedback = (isCorrect, correctAnswerText) => {
  if (isCorrect) {
    return 'Correct!';
  }

  if (correctAnswerText) {
    return `Incorrect. The correct answer is: ${correctAnswerText}`;
  }

  return 'Incorrect.';
};

export const normalizeQuizApiData = (quizPayload) => {
  const questions = Array.isArray(quizPayload)
    ? quizPayload
    : Array.isArray(quizPayload?.questions)
      ? quizPayload.questions
      : [];

  return questions.map((question) => {
    const answers = Array.isArray(question?.answers) ? question.answers : [];
    const correctIndexes = answers.reduce((indexes, answer, answerIndex) => {
      if (answer?.correct === true) {
        indexes.push(answerIndex);
      }

      return indexes;
    }, []);
    const isMultiSelect = correctIndexes.length > 1;
    const correctAnswerText = cleanQuizText(
      answers[correctIndexes[0]]?.answer,
    );

    return {
      questionId: question?.questionId ?? null,
      header: cleanQuizText(question?.header),
      question: cleanQuizText(question?.question),
      options: answers.map((answer) => {
        const answerText = cleanQuizText(answer?.answer);

        return {
          answerId: answer?.answerId ?? null,
          text: answerText,
          feedback:
            cleanQuizText(answer?.feedback) ||
            buildFallbackFeedback(answer?.correct === true, correctAnswerText),
        };
      }),
      ...(isMultiSelect
        ? {
            selectionType: 'multi',
            correctIndexes,
          }
        : {
            correctIndex: correctIndexes[0] ?? -1,
          }),
    };
  });
};
